import { fireTrack } from "@swa-ui/analytics";

import { DOCUMENT_TYPES } from "./defines/documentTypes";

export const fireScanDocumentAnalytics = (idType, isCancel) => {
  const action = isCancel ? "cancel scan" : "scan";

  if (idType === "PermanentResidentCard") {
    fireTrack("squid", { page_description: `button: ${action} resident card` });
  } else if (idType === "Passport") {
    fireTrack("squid", { page_description: `button: ${action} passport book` });
  }
};

export const fireScanResponseAnalytics = (errorMessage) => {
  if (errorMessage) {
    fireTrack("squid", {
      page_description: "scan: scan fail",
      scanpassportfailreasonings: errorMessage,
    });
  } else {
    fireTrack("squid", {
      page_description: "scan: scan capture",
    });
  }
};

export const fireDocumentVerifyAnalytics = (documentType, isCancel) => {
  const action = isCancel ? "cancel" : "save";

  if (documentType === DOCUMENT_TYPES.PERMANENT_RESIDENT_CARD) {
    fireTrack("squid", { page_description: `button: scan resident card ${action}` });
  } else if (documentType === DOCUMENT_TYPES.PASSPORT) {
    fireTrack("squid", { page_description: `button: scan passport ${action}` });
  }
};
